import AbstractController from '../../../../../vendors/services/abstractController';
import {useState} from 'react';
import ContribuicaoService from '../../../../services/contribuicao.service';
import ContribuicaoModel from '../../../../shared/model/contribuicao.model';

export default class MinhaContribuicaoController extends AbstractController {

  public service: ContribuicaoService;

  public tab: any;
  public setTab: any;
  public list: any;
  public setList: any;
  public total: any;
  public setTotal: any;
  public searchParam: any;
  public setSearchParam: any;

  public lazyParams: any;
  public setLazyParams: any;

  public contribuicao: ContribuicaoModel;

  constructor() {
    super();
    [this.tab, this.setTab] = useState('');
    [this.list, this.setList] = useState([]);
    [this.total, this.setTotal] = useState(0);
    [this.lazyParams, this.setLazyParams] = useState({
      first: 0,
      rows: 10,
      page: 1,
    });
    [this.searchParam, this.setSearchParam] = useState('');
    this.service = new ContribuicaoService();

    this.contribuicao = new ContribuicaoModel();
  }

  async init() {
    const state = this.location.state;
    super.init();
    if (!!state && !!state.desiredTab) {
      this.changeTab(state.desiredTab);
    } else {
      const params = new URLSearchParams(window.location.search);
      if (params.get('tab') != undefined) {
        this.changeTab(params.get('tab'));
      } else {
        this.changeTab('1');
      }
    }

    this.start();
    const context: any = this;
    const _contribuicao = await this.obterContribuicao(context);
    this.stop();

  }

  async obterContribuicao(context: any) {
    try {
      const res: any = await context.service.getEvento(context.getId(), context.codContribuinteLogado + 0);
      context.evento.sync(res.result);
      context.setLista([]);
      context.extrairLista(res.result.propostaNorma)
      context.setExisteContribuicao(res.result.qtdContribuicoesPorContribuinte == 0);
      return res.result;
    } catch (e) {
      return {success: false, error: e};
    }

  }

  onPage(e: any) {
    this.changeTab(this.tab, e.page, e.rows, false, e);
  }

  changeTab(value: any, page: number = 0, pageSize: number = 10, isClean = false, e?: any, ordering: any = null) {

    const obj: any = {
      codigoContribuinte: this.getCodContribuinte(),
      codigoMinhaContribuicaoSituacao: value,
      busca: this.searchParam,
      pageSize: 10
    };
    obj.page = page;
    obj.pageSize = pageSize;
    if (isClean) {
      obj.page = 0;
      obj.pageSize = 10;
    }
    if (ordering != null) {
      obj.ordering = ordering;
    }
    this.start();
    this.service.getMinhaContribuicao(obj).then((res: any) => {
      this.setTab(value);
      this.stop();
      if (e) {
        this.setLazyParams(e);
      }
      if (res.result && res.result.items) {
        this.setList(res.result.items);
        this.setTotal(res.result.totalItems);
      } else {
        this.setList([]);
        this.setTotal(0);
      }
    }).catch((err) => this.stop());
  }


}
